export const strings = {
  requestaborted: "Request was aborted",
  missingrefreshtoken: "Missing refresh token",
  invalidrefreshresponse: "Invalid refresh response",
  confirmDeleteTitle: "Confirm Delete",
  areyousureyouwanttodelete: "Are you sure you want to delete?",
  ok: "Ok",
  cancel: "Cancel",
  confirmLogoutTitle: "Confirm Logout",
  areyousureyouwanttologout: "Are you sure you want to logout?",
  loading: "Loading...",
  nolaungugeavailable: "No language available",
  Showing: "Showing",
  to: "to",
  of: "of",
  nooptionsavailable: "No options available",
  dashboard: "Dashboard",
  staticStrings: "Static Strings",
  staticContent: "Static Content",
  question: "Question",
  question2: "question",
  hcps: "HCPs",
  admin: "Admin",
  adminData: "Admin Data",
  lastlogin: "Last Login",
  signout: "Sign Out",
  countrydata: "Country Data",
  countryadmin: "Country Admin",
  superadmin: "Super Admin",
  super_admin: "superAdmin",
  country_admin: "countryAdmin",
  invalidcredentials: "Invalid credentials",
  unknownrolefound: "Unknown role found.",
  pleaselogintocontinue: "Please login to continue.",
  rememberme: "Remember Me",
  signin: "Sign In",
  userName: "userName",
  password: "password",
  remember_me: "rememberMe",
  remember_me2: "remember-me",
  userName2: "Username",
  password2: "Password",
  dashboarddescription: "Display all counts of patients, HCPs and hospitals.",
  totalhcps: "Total HCPs",
  totalpatients: "Total Patients",
  failtoloaddashboard: "Failed to load dashboard",
  addHcpTitle: "Add Healthcare Provider (HCP)",
  addHcp: "Add HCP",
  adding: "Adding...",
  firstName: "First Name",
  firstName2: "firstName",
  lastName: "Last Name",
  lastName2: "lastName",
  email: "Email",
  email2: "email",
  hospitalName: "Hospital Name",
  hospitalName2: "hospitalName",
  firstNamePlaceholder: "Enter first name",
  lastNamePlaceholder: "Enter last name",
  emailPlaceholder: "Enter email address",
  hospitalNamePlaceholder: "Enter hospital name",
  firstNameRequired: "First name is required",
  firstNameMin: "First name must be at least 2 characters",
  firstNameMax: "First name must not exceed 50 characters",
  firstNameInvalid: "First name can only contain letters, spaces, hyphens, and apostrophes",
  lastNameRequired: "Last name is required",
  lastNameMin: "Last name must be at least 2 characters",
  lastNameMax: "Last name must not exceed 50 characters",
  lastNameInvalid: "Last name can only contain letters, spaces, hyphens, and apostrophes",
  emailRequired: "Email is required",
  emailInvalid: "Please enter a valid email address",
  emailMax: "Email must not exceed 100 characters",
  hospitalRequired: "Hospital name is required",
  hospitalMin: "Hospital name must be at least 2 characters",
  hospitalMax: "Hospital name must not exceed 100 characters",
  enterFirstName: "Enter first name",
  enterLastName: "Enter last name",
  enterEmail: "Enter email address",
  enterHospitalName: "Enter hospital name",
  hcp: "HCP",
  hcpdescription: "Manage and monitor all HCPs in your system",
  addnewhcp: "Add New HCPs",
  errorLoadingHcps: "Error Loading HCPs",
  refferalCode: "Referral Code",
  country: "Country",
  questionarabic: "سؤال",
  noChanges: "No changes detected",
  questionRequired: "Question is required",
  requiredOptions: "Exactly 4 options are required",
  requiredQuestionNo: "Question number is required",
  questiondescription: "Manage healthcare questions for different languages",
  noQuestionsFoundfor: "No questions found for",
  addQuestion: "+ Add Question",
  editQuestion: "Edit Question",
  edit: "Edit",
  edit2: "edit",
  deleteQuestion: "Delete Question",
  Options: "Options",
  questionNo: "Question No",
  enterQuestionNumber: "Enter question number",
  enterYourQuestion: "Enter your question",
  enterNotesOptional: "Enter notes (optional)",
  update: "Update",
  add: "Add",
  warning: "Warning",
  delete: "Delete",
  addoption: "+ Add option",
  contentEditor: "Content Editor",
  save: "Save",
  saveContent: "Save Content",
  updateContent: "Update Content",
  starttowrite: "Start typing your content here...",
  staticContentTitle: "Static Content",
  staticContentDescription: "Manage static content for different languages and sections",
  contactUs: "Contact us",
  privacyPolicy: "Privacy Policy",
  aboutMG: "About MG",
  adverseReporting: "Adverse Reporting",
  selectValidTab: "Please select a valid tab",
  selectLanguage: "Please select a language",
  emptyContentError: "Please add some content before saving",
  noChangesDetected: "No changes detected",
  staticContentSaveFailed: "Failed to save content.",
  staticContentSaved: "Static content saved successfully",
  staticContentUpdated: "Static content updated successfully",
  selectLanguageToView: "Please select a language to view static content",
  noLanguagesAvailable: "No Languages Available.",
  noContentAvailable: "No content available.",
  addStaticString: "Add Static String",
  addsingleString: "Add Single String",
  json: "JSON",
  single: "Single",
  addviaJSON: "Add via JSON",
  pleaseSelectLanguage: "Please select a language first",
  bothareRequired: "Both key and value are required",
  keyAlreadyExists: "This key already exists. Please use a different key.",
  invalidKey: "Invalid key. Only alphanumeric characters, underscores, and dots are allowed.",
  keyMinLength: "Key must be at least 2 characters long.",
  parseinputError: "Parsed input is not a valid object.",
  invalidJSONFormat: "Invalid JSON format. Paste a valid object like: { login: 'Login', signup: 'Sign Up' }",
  valueisrequired: "Value is required",
  noitemfordeletion: "No item selected for deletion",

  addJsonTitle: "Add JSON Strings",
  updateTitle: "Update String",
  savejson: "Save JSON",
  keyLabel: "Key",
  valueLabel: "Value",
  jsonLabel: "JSON Object",
  action: "Action",
  keyPlaceholder: "e.g. login, signup, welcome",
  jsonPlaceholder: `Paste JSON here, e.g.\n{\n  "login": "Login",\n  "signup": "Sign Up",\n  "welcome`,
  nostringsfound: "No strings found.",
  nostringsavailablefor: "No static strings available for ",
  invalidKeyformat: "Invalid key format.",
  countrynamerequired: "Country name is required.",
  usernameisrequired: "Username is required.",
  passwordisrequired: "Password is required.",
  emailisrequired: "Email is required.",
  invalidemail: "Invalid email",
  countryuadminadded: "Country admin added successfully!",
  failedtoaddcountryadmin: "Failed to add country admin",
  addcountryadmin: "Add Country Admin",
  countryName: "Country Name",
  countryName2: "countryName",
  username: "Username",
  selectcountry: "Select a country",
  countryadmintitle: "Country Admin Management",
  countryadmindescription: "Manage country admin accounts and credentials",
  addcountryadminbutton: "+ Add Country Admin",
  countryName3: "Country Name",
  noadminaccountsfound: "No admin accounts found",
  getstartedbyaddingfirstcountryadmin: "Get started by adding your first country admin",
  countrydatamanagement: "Country Data Management",
  displaycountryname: "Display country name, status, e-mail and supported languages",
  nocountrydataavailable: "No country data available",
  nocountryfound: "No countries found",
  nolaungugeconfigured: "No languages configured",
  supportedlanguages: "Supported Languages:",
  staticStringsDescription: "Manage translation strings for different languages",
  mobileNumber: "mobileNumber",
  mobileNumber2: "Mobile Number",
  max8queRequired: " Maximum 8 questions allowed",
  hospital: "Hospital",
  hospitalDescription: "Manage and monitor all hospitals in your system",
  addNewHospital: "Add New Hospital",
  name: "Name",
  city: "City",
  view: "View",
  viewHospital: "View Hospital",
  state: "State",
  address: "Address",
  hcpDetails: "Hcps Details",
  hospitalIdNotFound: "Hospital ID not found",
  noChangesToUpdate: "No changes to update",
  editHcpTitle: "Edit Healthcare Provider (HCPs)",
  hcpIdNotFound: "HCP id not found",
  referralCodeIsRequired: 'Referral code is Required"',
  addressRequired: "Address is Required",
  cityRequired: "City is Required",
  stateRequired: "State is Required",
  mobileCoderequired: "Mobile code is Required",
  mobileNumberRequired: "Mobile number is Required",
  mobileNumberValidationNumber: "Mobile number must be 10 digits",
  verifyOtp: "Verify OTP",
  enter6DizitOtp: "Enter the 6 digit OTP sent to you",
  sendotp: "Send OTP",
  emailAddress: "E-Mail Address",
  enterDigitOtp: "Enter valid 6 digit OTP",
  otpSendTo: "OTP sent to",
  didNotReceiveCode: "Didn’t receive OTP?",
  verifying: "Verifying...",
  veryfingOtp: "Verify OTP",
  resending: "Resending...",
  resendOtp: "Resend OTP",
  resendIn: "Resend in",
  close: "Close",
  second: "s",
  code: "Mobile Code",
  mobileRequired: "Mobile Code Is Required",
  referralCodeMustBe: "Referral code must be exactly 4 digits",
  refferalCodePlaceholder: "Enter 4 Digit Referral Code",
  noDataFound: "No Data Found",
  emptyHcp: "No Healthcare Providers Found",
  emptyHcpDesctiption: "Get started by adding your first healthcare provider to the system.",
  emptyHospital: "No Hospital Found",
  emptyHospitalDesctiption: "Get started by adding your first Hospital to the system.",
  settings: "Settings",
  settingsTitle: "Settings",
  totalStrings: "Total Strings",

  addAppVersion: "Add App Version",
  updateAppVersion: "Update App Version",
  appVersion: "App Version",
  androidAppVersion: "Latest Android App Version",
  iosAppVersion: "Latest iOS App Version",
  androidLink: "Android Link",
  iosLink: "iOS Link",
  addAndroidAppVersion: "Add Android App Version",
  addIosAppVersion: "Add iOS App Version",
  addAndroidLink: "Add Android Link",
  addIosLink: "Add ios Link",
  androidVersionRequired: "Android version is required",
  iosVersionRequired: "iOS version is required",
  androidLinkInvalid: "Android link must be a valid URL",
  iosLinkInvalid: "iOS link must be a valid URL",
  enterVersionsAndLinks: "Enter versions and store links.",
  saveChanges: "Save Changes",
  saveAndAdd: "Save & Add",
  noAppVersionAdded: "No app version added yet.",
  errorLoadingVersion: "Error loading version:",
  updated: "Updated:",
  confirmUpdate: "Confirm Update",
  confirmUpdateMessage:
    "Are you sure you want to update the app version? This change will be visible to all users immediately.",
  yes: "Yes",
  no: "No",
  updating: "Updating...",
  versionUpdatedSuccess: "App version updated successfully!",
  versionUpdateFailed: "Failed to update app version",
  updateVersionWarning:
    "Updating the app version will impact all users . Please confirm that the new version is already published on the respective app stores before updating.",

  lastUpdatedAt: "Last Updated At",
  patient: "Patient",
  settingDescription: "Manage Application's Version , Code and Links",
  mobileInvalid: "Invalid mobile number",
  enterMobileNumber: "Enter Mobile Number",
  androidAppCode: "Android App Code",
  addAndroidAppCode: "Add Android App Code",
  iosAppCode: "iOS App Code",
  addIosAppCode: "Add iOS App Code",
  android: "Android",
  ios: "iOS",
  editHospital: "Edit Hospital",
  addHospital: "Add Hospital",
  totalHospital: "Total Hospitals",
  hospitalRefferalCode: "Hospital Referral Code",
  requests: "Requests",
  requestsDescription: "Manage and track requests from HCPs and hospitals",
  createdBy: "Created By",
  confirmpassword: "Confirm Password",
  confirmpasswordisrequired: "Confirm Password is required",
  passwordmismatch: "Passwords must match",
  requestTitle: "HCPs Requests",

  noPendingRequests: "No Pending Requests",
  allHealthcareProviderRequestsProcessed: "All HCPs requests have been processed.",
  approve: "Approve",
  reject: "Reject",
  confirmApproval: "Confirm Approval",
  confirmRejection: "Reject Request",
  approvalMessage: "Are you sure you want to approve the registration request for",
  rejectionMessage: "Please provide a reason for rejecting the request from",
  rejectionReason: "Rejection Reason",
  enterRejectionReason: "Enter reason here...",
  approving: "Approving...",
  rejecting: "Rejecting...",
  requestApproved: "Request approved successfully!",
  requestRejected: "Request rejected successfully!",
  failedToUpdateRequest: "Failed to update request status",
  action2: "ACTION",
};
